module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/product-list/product-list.component.scss
// module id = 1497
// module chunks = 0